import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=88637fda&scoped=true&"
import script from "./Metadata.vue?vue&type=script&lang=ts&"
export * from "./Metadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88637fda",
  null
  
)

export default component.exports